import DevLog from '../../devlog/Module'
import ViewportModule from '../../viewport/Module'
import PreviewModule from '../../preview/Module'
import errorAction from '../../../actions/error/errorAction'
import transferActionProps from '../transferActionProps'
import { doPost } from '../doPost'

import { ActionType, IAction, SurveyMode } from '../../../actions/types'
import { QuestionID } from '../../../questions/types'
import { ModuleID } from '../../types'
import { IErrorResponse, IRequestSurveyModeChangeBody } from '../types'

import { DEBUG_CLIENT } from '../const'
import { getURLfromAction } from '../lib'
import ClientModule from '../Module'

export default async function requestSurveyModeChange(fromAction: IAction, mode: SurveyMode, target?: QuestionID) {
  const resetSession =
    ActionType.ASK !== fromAction.action ||
    !fromAction.action_url ||
    (mode === SurveyMode.RESPONDENT &&
      (fromAction.mode === SurveyMode.RESEARCHER || fromAction.mode === SurveyMode.XRAYS)) ||
    (mode === SurveyMode.RESEARCHER && fromAction.mode === SurveyMode.XRAYS)

  const body: IRequestSurveyModeChangeBody = {
    device: ViewportModule.viewport.device,
    mode: mode,
    proxy_params: resetSession ? {} : fromAction.action_proxy_params,
    payload: ClientModule.data_values
      ? { data_values: ClientModule.data_values, name: 'change_mode', target: target }
      : !resetSession ||
        fromAction.preview?.hard_reset ||
        fromAction.preview?.locales?.length < 2 ||
        mode == SurveyMode.RESPONDENT ||
        !ClientModule.locale
      ? { name: 'change_mode', target: !resetSession && target ? target : void 0 }
      : { name: 'set_locale', target: fromAction.data?.locale?.aytm_locale || ClientModule.locale }
  }

  const urlParams = new URLSearchParams(location.href)
  if (urlParams.get('versionUID')) body.versionUID = urlParams.get('versionUID')
  if (urlParams.get('snippetUID')) body.snippetUID = urlParams.get('snippetUID')
  if (urlParams.get('templateID')) body.templateID = urlParams.get('templateID')

  if (DEBUG_CLIENT) {
    DevLog._log(`SW[${ModuleID.CLIENT}]:`, 'requestSurveyModeChange', body)
  }

  const resetURL = PreviewModule.resetURL || fromAction.action_url
  const actionURL = resetSession ? resetURL : fromAction.action_url

  let nextAction = errorAction({ ...fromAction, mode })

  if (actionURL) {
    try {
      const response = await doPost<IAction | IErrorResponse>(getURLfromAction(fromAction, actionURL), body).catch(
        error => {
          DevLog.error(error, `SW[${ModuleID.CLIENT}]:`, 'requestSurveyModeChange')
          return errorAction({ ...fromAction, mode })
        }
      )
      nextAction =
        'error' === (response as IErrorResponse).status ? errorAction({ ...fromAction, mode }) : (response as IAction)
      if (!nextAction.mode) {
        nextAction.mode = mode
      }
    } catch (error) {
      DevLog.error(error, `SW[${ModuleID.CLIENT}]:`, 'requestSurveyModeChange')
    }
  } else {
    DevLog.error(new Error('no actionURL'), `SW[${ModuleID.CLIENT}]:`, 'requestSurveyModeChange', {
      action: fromAction,
      resetURL: PreviewModule.resetURL,
      resetSession
    })
  }

  return transferActionProps(fromAction, nextAction)
}
